import { Intent, Spinner } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import omit from "lodash/omit";

import { Query } from "core/api/typedQuery";
import EntityForm from "core/components/EntityForm";
import { Component } from "react";
import TokenSession from "../../../../core/util/session/TokenSession";
import { TopicSubscription } from "../../entity/TopicSubscription";
import { ForumToaster } from "../../forumActions";


interface ITopicSubscriptionFormProps {
	topicId: number; // if topic id is undefined we set the
	onAfterSave?: (topic: TopicSubscription) => void
}

const SubQuery = Query.queryMany<TopicSubscription, {topicId: number}>(TopicSubscription);

export default class TopcicSubscriptionForm extends Component<ITopicSubscriptionFormProps> {

	constructor(props) {
		super(props);
	}

	@autobind
	private onBeforeSave(sub: TopicSubscription) {
		const s = {...sub};

		s.topic = this.props.topicId;

		// temp. service should do this automatically on backend
		s.user = TokenSession.getUserId();

		// temp. service should accept same data type for query and mutation
		return omit(s, "topicEntity");
	}

	@autobind
	private onAfterSave(result: TopicSubscription) {

		ForumToaster.show({
			intent: Intent.SUCCESS,
			message: "Topic subscription updated"
		});

		if(this.props.onAfterSave) {
			this.props.onAfterSave(result);
		}
	}

	public render() {
		return (
			<SubQuery params={{topicId: this.props.topicId}}>
				{
					({data, loading}) => {

						if(loading) {
							return <Spinner/>;
						}

						return <EntityForm instance={data && data.length && data[0]} clazz={TopicSubscription} refetch={false} beforeSave={this.onBeforeSave} afterSave={this.onAfterSave} />
					}
				}
			</SubQuery>
		);
	}
}




// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/TopicSubscriptionForm.tsx